import React, { CSSProperties } from 'react'
import Icon from 'meinian-package/src/component/icon'
import css from './card.module.less'

export type CardProps = {
  image: string
  title: string
  subTitle: string
  path: string
  onClick: () => void,
  style?: CSSProperties
}
export default function Card({ image, path, title, subTitle, onClick, style }: CardProps) {
  return (
    <div className={css.card} onClick={onClick} style={style}>
      <img className={css.image} alt={`${title}`} src={image} />
      <div className={css.desc}>
        {path && (
          <div title={`${path}`} className={css.title}>
            <Icon type="m-wenjianjia" style={{ marginRight: 2 }} />
            {path}
          </div>
        )}
        <div title={`${title}`} className={css.title}>
          {title}
        </div>
        <div title={subTitle} className={css.subTitle}>
          {subTitle}
        </div>
      </div>
    </div>
  )
}
